import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { ExternalLink } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { useLanguage } from '../context/LanguageContext';

const Sectors = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [tabsRef, tabsVisible] = useScrollAnimation();
  const { t, language } = useLanguage();

  const paperPartners = [
    { name: 'Classic Fashion Company', url: 'classicfashion.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/vdv59tri_438128756_1038129134986060_2427921282831470345_n.jpg' },
    { name: 'GIA Apparels Industry', url: 'https://www.linkedin.com/company/gia-apparels-industry', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/bv5ni81l_1662012387283.jpeg' },
    { name: 'MAS Holdings', url: 'https://masholdings.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/ui329umj_482013712_993511082875182_7588153434703280164_n.jpg' },
    { name: 'Epic Group', url: 'https://www.epicgroup.global/corpinfo25v1/', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/hz1gp576_241741112_368082744810932_1956568464472689505_n.png' },
    { name: 'QVJ Aqaba', url: 'https://www.linkedin.com/company/qvj-aqaba', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/ez3yl7lg_sidney_apparels_logo.jpeg' },
    { name: 'Jerash Holdings', url: 'jerashholdings.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/z24trnnk_jerash_logo001.jpg' },
    { name: 'BIA Textiles Manufacturing', url: 'https://www.linkedin.com/company/bia-textiles', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/e3cok4mr_bia_textiles_logo.jpeg' },
  ];

  const foodBrands = [
    {
      name: 'Nude Mints',
      url: 'nudemints.com',
      image: 'https://customer-assets.emergentagent.com/job_paper-experts/artifacts/vnqnjdzg_NUDE_VARIETY-PACK_ONESHOT.jpg-2.webp'
    },
    {
      name: 'Evil Snacks',
      url: 'evilsnacks.com',
      image: 'https://customer-assets.emergentagent.com/job_paper-experts/artifacts/ua0ye6xc_08789a0d-950b-43f7-82ce-4b39bfcf606e.__CR0%2C0%2C970%2C600_PT0_SX970_V1___.png'
    },
  ];

  const distributionPartners = [
    { name: 'More Care International Trade Co.', locationKey: 'saudiArabia', url: 'https://morecare.net', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/vaj7nrnh_cropped-cropped-Morecare-1.png' },
    { name: 'Better Health LLC', locationKey: 'uae', url: 'https://www.betterhealthuae.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/u183v37v_betterhealth-logo-1.png' },
    { name: 'Sharaya Drug Store', locationKey: 'jordan', url: 'https://sharayadrugstore.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/4iydswyi_306186784_5363520483755324_4328999690752482842_n%20%281%29.jpg' },
    { name: 'Medica Energy', locationKey: 'kuwait', url: 'https://www.order-medicaenergy.com/cart/', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/14p1nqdf_Artboard_14x.png' },
    { name: 'Macro Boost', locationKey: 'oman', url: 'https://www.macroboost.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/f96wst45_6f1130_022ad030894d4f7492601556463b7dd9~mv2.png' },
    { name: 'Al-Thakaa Trade', locationKey: 'iraq', url: 'https://allthakaa.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/bak3rd95_Screenshot%202026-01-09%20at%2015.39.16.png' },
    { name: 'Al-Ataa Pharmacy', locationKey: 'qatar', url: 'https://linktr.ee/alataa_pharmacy', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/26g1cqfh_581019805_1341053241365385_4181589387062650460_n.jpg' },
    { name: 'Sharekat Al-Daher', locationKey: 'palestine', url: 'https://thaher.ps', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/k3uzebm4_66a217104385f.png' },
    { name: 'Pharmica Co. LLC', locationKey: 'lebanon', url: 'https://pharmicacompany.com', logo: 'https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/z7dzp3o8_pharmica_co_logo.jpeg' },
  ];

  const isRTL = language === 'ar';
  const textAlign = isRTL ? 'text-right' : 'text-left';

  return (
    <section id="sectors" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div 
          ref={headerRef}
          className={`text-center mb-16 animate-on-scroll ${headerVisible ? 'animate-visible' : ''}`}
        >
          <h2 className="headline-font text-4xl md:text-5xl text-slate-900 mb-4">{t('services.title')}</h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div
          ref={tabsRef}
          className={`animate-on-scroll ${tabsVisible ? 'animate-visible' : ''}`}
        >
          <Tabs defaultValue="paper" className="max-w-7xl mx-auto">
            <TabsList className="grid w-full grid-cols-1 md:grid-cols-3 mb-12 h-auto">
              <TabsTrigger value="paper" className="py-4 text-base">
                {t('services.tab1')}
              </TabsTrigger>
              <TabsTrigger value="food" className="py-4 text-base">
                {t('services.tab2')}
              </TabsTrigger>
              <TabsTrigger value="business" className="py-4 text-base">
                {t('services.tab3')}
              </TabsTrigger>
            </TabsList>

            {/* Paper Trading */}
            <TabsContent value="paper" className="mt-8">
              <Card className="border-none shadow-xl">
                <CardHeader className={`bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 ${textAlign}`}>
                  <CardTitle className="subheadline-font text-2xl text-slate-800">
                    {t('services.paperTitle')}
                  </CardTitle>
                  <p className="text-gray-700 italic mt-2">{t('services.paperQuote')}</p>
                </CardHeader>
                <CardContent className={`p-8 ${textAlign}`}>
                  <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    {t('services.paperText')}
                  </p>

                  {/* Paper Manufacturing Images */}
                  <div className="grid md:grid-cols-3 gap-6 mb-8">
                    <div className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <img
                        src="https://customer-assets.emergentagent.com/job_paper-experts/artifacts/ts7hd4kt_csm_2020_STP_FlorianThoss_DSCF4147_RGB_64491536e4.jpg.webp"
                        alt="Paper Manufacturing"
                        className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <img
                        src="https://images.pexels.com/photos/31788399/pexels-photo-31788399.jpeg"
                        alt="Printing Facility"
                        className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <img
                        src="https://customer-assets.emergentagent.com/job_paper-experts/artifacts/rhouxd3y_646de6bdd8a3d092c0a3feb4_43.jpg"
                        alt="Manufacturing Floor"
                        className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  </div>

                  <h4 className="font-bold text-xl text-gray-900 mb-4">{t('services.partners')}</h4>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-6">
                    {paperPartners.map((partner, index) => (
                      <a
                        key={index}
                        href={partner.url.startsWith('http') ? partner.url : `https://${partner.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`partner-logo-${index}`}
                        className="bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center group border border-gray-100 hover:border-blue-200"
                      >
                        <img
                          src={partner.logo}
                          alt={partner.name}
                          className="h-16 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                          title={partner.name}
                        />
                      </a>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Brand Management */}
            <TabsContent value="food" className="mt-8">
              <Card className="border-none shadow-xl">
                <CardHeader className={`bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 ${textAlign}`}>
                  <CardTitle className="subheadline-font text-2xl text-slate-800">{t('services.brandTitle')}</CardTitle>
                  <p className="text-gray-700 italic mt-2">{t('services.brandQuote')}</p>
                </CardHeader>
                <CardContent className={`p-8 ${textAlign}`}>
                  <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    {t('services.brandText')}
                  </p>

                  <h4 className="font-bold text-xl text-gray-900 mb-6">{t('services.managedBrands')}</h4>
                  <div className="grid md:grid-cols-2 gap-8 mb-12">
                    {foodBrands.map((brand, index) => (
                      <Card key={index} className="overflow-hidden hover:shadow-xl transition-shadow duration-300">
                        <div className="h-80 overflow-hidden bg-white flex items-center justify-center p-3">
                          <img
                            src={brand.image}
                            alt={brand.name}
                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                        <CardContent className="p-6">
                          <h5 className="font-bold text-xl text-gray-900 mb-2">{brand.name}</h5>
                          <a
                            href={`https://${brand.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-700 flex items-center gap-2 hover:text-blue-900 transition-colors duration-200"
                          >
                            {brand.url}
                            <ExternalLink className="w-4 h-4" />
                          </a>
                        </CardContent>
                      </Card>
                    ))}
                  </div>

                  <h4 className="font-bold text-xl text-gray-900 mb-4">{t('services.distributionPartners')}</h4>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
                    {distributionPartners.map((partner, index) => (
                      <div key={index} className="flex flex-col items-center">
                        {partner.logo ? (
                          <a
                            href={partner.url.startsWith('http') ? partner.url : `https://${partner.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`distribution-partner-logo-${index}`}
                            className="bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center group border border-gray-100 hover:border-blue-200 w-full"
                          >
                            <img
                              src={partner.logo}
                              alt={partner.name}
                              className="h-16 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                              title={partner.name}
                            />
                          </a>
                        ) : partner.url ? (
                          <a
                            href={partner.url.startsWith('http') ? partner.url : `https://${partner.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-blue-50 p-4 rounded-lg hover:bg-blue-100 transition-colors duration-200 w-full text-center"
                          >
                            <p className="font-semibold text-blue-700 hover:text-blue-900 transition-colors duration-200 flex items-center justify-center gap-1">
                              {partner.name}
                              <ExternalLink className="w-3 h-3" />
                            </p>
                          </a>
                        ) : (
                          <div className="bg-blue-50 p-4 rounded-lg w-full text-center">
                            <p className="font-semibold text-gray-900">{partner.name}</p>
                          </div>
                        )}
                        <p className="text-sm text-gray-600 mt-2 font-medium">{t(`locations.${partner.locationKey}`)}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Business Development */}
            <TabsContent value="business" className="mt-8">
              <Card className="border-none shadow-xl">
                <CardHeader className={`bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 ${textAlign}`}>
                  <CardTitle className="subheadline-font text-2xl text-slate-800">
                    {t('services.businessTitle')}
                  </CardTitle>
                  <p className="text-gray-700 italic mt-2">{t('services.businessQuote')}</p>
                </CardHeader>
                <CardContent className={`p-8 ${textAlign}`}>
                  <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    {t('services.businessText')}
                  </p>

                  {/* Business Development Images */}
                  <div className="grid md:grid-cols-2 gap-6 mb-8">
                    <div className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <img
                        src="https://customer-assets.emergentagent.com/job_paper-experts/artifacts/pvw8fy4t_66ed91b1f420c0f93f50c292_exportation_et_partenariats_commerciaux_1200x630.jpeg"
                        alt="Business Partnership"
                        className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <img
                        src="https://customer-assets.emergentagent.com/job_paper-experts/artifacts/d7wxhe7m_is_business_development_a_good_career.webp"
                        alt="Business Development"
                        className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  </div>

                  <div className="bg-blue-50 p-6 rounded-lg mb-8">
                    <h4 className="font-bold text-xl text-gray-900 mb-4">{t('services.partners')}</h4>
                    <div className="bg-white p-4 rounded-lg">
                      <p className="font-semibold text-gray-900">{t('services.businessPartnerName')}</p>
                      <p className="text-gray-600 mt-2">
                        {t('services.businessPartnerDesc')}
                      </p>
                    </div>
                  </div>

                  <h4 className="font-bold text-xl text-gray-900 mb-4">{t('services.ourApproach')}</h4>
                  <div className="grid md:grid-cols-3 gap-6">
                    <div className="text-center p-6 bg-gradient-to-b from-blue-50 to-white rounded-lg">
                      <div className="bg-gray-800 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                        <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{t('services.approach1Title')}</h5>
                      <p className="text-gray-600 text-sm">{t('services.approach1Text')}</p>
                    </div>
                    <div className="text-center p-6 bg-gradient-to-b from-blue-50 to-white rounded-lg">
                      <div className="bg-gray-800 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                        <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{t('services.approach2Title')}</h5>
                      <p className="text-gray-600 text-sm">{t('services.approach2Text')}</p>
                    </div>
                    <div className="text-center p-6 bg-gradient-to-b from-blue-50 to-white rounded-lg">
                      <div className="bg-gray-800 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                        <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                      </div>
                      <h5 className="font-bold text-gray-900 mb-2">{t('services.approach3Title')}</h5>
                      <p className="text-gray-600 text-sm">{t('services.approach3Text')}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default Sectors;
